<template>
  <div class="chip-estado-acuerdo-comercial">
    <ca-chip
      :item="{ label: getTituloEstadoAcuerdoComercial(estado) }"
      disabled
      :class="'estado-acuerdo-comercial--' + colorEstadoAcuerdoComercial()"
      class="estado-acuerdo-comercial"
    >
    </ca-chip>
  </div>
</template>

<script>
import { getTituloEstadoAcuerdoComercial, TiposEstadosAcuerdoComercial } from '../acuerdo-comercial.consts';

export default {
  name: 'ChipEstadoAcuerdoComercial',
  /**
   *  estado: string, es la key del estado del acuerdo comercial
   *  (Este estado puede ser tambien el caso de acuerdo comercial expirado y administracion, estos no son estados como tal pero se muestran como los estados de los chips con un estilo propio de cada uno)
   */
  props: {
    estado: { type: String, default: '' }
  },
  methods: {
    getTituloEstadoAcuerdoComercial,

    /**
     * Método que retorna el estilo del color del chip del estado del acuerdo comercial
     * El estilo del chip depende del estado del acuerdo comercial
     * El chip para acuerdo comercial para la administración y el chip para cuando se encuentra expirada son casos especiales. No son estados como tal pero se muestran como los estados de los chips con un estilo propio de cada uno
     */
    colorEstadoAcuerdoComercial() {
      switch(this.estado) {
      case TiposEstadosAcuerdoComercial.NUEVA:
        return 'nueva';
      case TiposEstadosAcuerdoComercial.RECHAZADA:
        return 'rechazada';
      case TiposEstadosAcuerdoComercial.RENEGOCIADA:
        return 'renegociada';
      case TiposEstadosAcuerdoComercial.ACEPTADA:
        return 'aceptada';
      case TiposEstadosAcuerdoComercial.ACTUALIZADA:
        return 'actualizada';
      case TiposEstadosAcuerdoComercial.EXPIRADO:
        return 'expirada';
      case TiposEstadosAcuerdoComercial.ADMINISTRACION:
        return 'administracion';
      default: // Estado del acuerdo comercial facturando
        return 'facturando';
      }
    },
  }
};
</script>

<style lang="scss">
.chip-estado-acuerdo-comercial {

  .estado-acuerdo-comercial {
    font-weight: 700;
    height: 20px !important;

    .v-chip__content {
      width: auto;
      font-size: 12px;
      padding: 3px 7px;
    }

    &--nueva {
      border: 1px solid color(gris-deshabilitado);

      .v-chip__content {
        background-color: color(blanco);
      }
    }

    &--rechazada {
      .v-chip__content {
        background-color: color(naranja-claro);
        color: color(dark-secund);
      }
    }

    &--renegociada {
      .v-chip__content {
        background-color: color(celeste-claro);
        color: color(dark-secund);
      }
    }

    &--aceptada {
      .v-chip__content {
        background-color: color(success);
        color: color(dark-secund);
      }
    }

    &--actualizada {
      border: 1px solid color(celeste-claro);

      .v-chip__content {
        background-color: color(gris-claro);
      }
    }

    &--expirada {
      margin-left: 5px;

      .v-chip__content {
        background-color: color(rojo-error);
        color: color(blanco);
      }
    }

    &--facturando {
      .v-chip__content {
        background-color: color(celeste);
        color: color(blanco);
      }
    }

    &--administracion {
      .v-chip__content {
        background-color: color(gris);
        color: color(blanco);
        font-weight: 700;
      }
    }
  }
}
</style>
